import React from 'react';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import cifrao from 'imagens/cifrao.png';
import interrogacao from 'imagens/interrogacao.png';
import { useDevice } from 'components/DeviceContext.js';



const CardComponent = ({ title, content, image, topics, backgroundColor }) => {
    const { isMobile, isTablet, isLaptop } = useDevice();
    // Função para lidar com o clique em um tópico
    const handleTopicClick = (link) => {
        window.location.href = link; // Redireciona para o link correspondente
    };

    return (
        <Grid container style={{ justifyContent: isMobile || isTablet ? 'center' : '' }}>
            <Grid item sx={12} sm={8} md={8} lg={10} style={{
                fontFamily: 'Myriad Pro',
                margin: '1em',
                // padding: isMobile ? '1em' : '1em '

            }}>
                <Card style={{ borderRadius: '1em', boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.5)' }}>
                    <Typography variant="h6" gutterBottom style={{ backgroundColor: backgroundColor, padding: isMobile ? '0.4em' : '0.6em', fontWeight: 700, color: 'var(--branco)', fontSize: isMobile ? '1em' : isLaptop ? '1em' : '', textAlign: 'center' }}>
                        {title}
                    </Typography>
                    <CardContent style={{ display: 'flex', fontWeight: '400' }}>
                        <Typography style={{ fontSize: '50px' }}>
                            {content}
                        </Typography>
                        <Grid item xs={10} md={11}  >
                            {topics.map((topic, index) => (
                                <Grid item key={index} style={{ marginBottom: '1em', fontSize: isMobile ? '1em' : isLaptop ? '1.1em' : '1.2em', fontFamily: 'Myriad Pro, sans-serif' }}>
                                    <a variant="contained" color="primary" onClick={() => handleTopicClick(topic.link)} >
                                        {topic.text}
                                    </a>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item xs={2} md={2}>
                            <img src={image} alt="Imagem" style={{ width: isMobile ? '80%' : '70%' }} />
                        </Grid>
                    </CardContent>
                </Card>

            </Grid>
        </Grid>

    );
};

const Card1 = () => {
    const card1Topics = [
        { text: '• As fontes de receita do FIA Municipal', link: '/obtencao-de-recursos' },
        { text: '• Instrumentos de Planejamento do FIA', link: '/instrumentos-de-planejamento' },
        { text: '• Opinião dos contadores municipais', link: '/opiniao-contadores' }
    ];



    return (
        <CardComponent
            title="Obtenção de recursos para o FIA Municipal"
            content=""
            image={cifrao}
            topics={card1Topics}
            backgroundColor="var(--azul)"
        />
    );
};

const Card2 = () => {
    const card2Topics = [
        { text: 'O que fazer com o recurso do FIA?', link: '/faq#acordeao1' },
        { text: 'Quem deve ser o Gestor do Fia Municipal?', link: '/faq#acordeao2' },
        { text: 'Como são feitas as destinações a partir do Imposto de Renda?', link: '/faq#acordeao3' }
    ];


    return (
        <CardComponent
            title="Perguntas e respostas sobre o FIA Municipal"
            content=""
            image={interrogacao}
            topics={card2Topics}
            backgroundColor="var(--laranja)"

        />
    );
};


export { Card1, Card2 };
